import { tableConfig } from '../../../settings/index';

export function onLoadMultiDaySuccess(state, { payload }) {
  const { data, filteredTotal, pageSize, currentPage, savedSearches, search } = payload;
  const { jobs: stateJobs } = state;
  let jobs;

  const getChildrenJobs = (items, job_group_id, currentJobsPage, totalJobsPages) => {
    const childrenJobs = items.map(item => ({ ...item, key: item.id, isChildJob: true }));

    // Additional row to show Load More button
    if (filteredTotal > pageSize || currentJobsPage < totalJobsPages) {
      childrenJobs.push({
        key: `load-more-${job_group_id}`,
        isLoadMoreRow: true,
        job_group_id,
        currentPage,
        totalPages: Math.ceil(filteredTotal / tableConfig.pageSize),
        savedSearches,
      });
    }

    return childrenJobs;
  };

  // Fill in additional children (level-1 rows) array for nested Multi Days jobs in the table
  if (Array.isArray(data) && data.length > 0) {
    jobs = stateJobs.map(record => {
      const { job_group_id, currentPage: currentJobsPage, totalPages } = record;
      const shouldHasChildrenJobs = job_group_id && job_group_id === data[0].job_group_id;

      return {
        ...record,
        ...(shouldHasChildrenJobs && { children: getChildrenJobs(data, job_group_id, currentJobsPage, totalPages) }),
      };
    });
  }

  return {
    ...state,
    jobs,
    loading: false,
    search,
  };
}
